/**
 * Indus PDP gallery — hero height sync, scroll reveals, light parallax.
 */
(function () {
  var section = document.querySelector('.main-product--indus');
  if (!section) return;

  var stickyCol = section.querySelector('.ic-pdp-sticky');
  var heroWrap = section.querySelector('.ic-pdp-gallery__hero');
  var heroImg = section.querySelector('.ic-pdp-gallery__img--hero');
  var heroLink = section.querySelector('.ic-pdp-gallery__link--hero');

  function syncHeroToBuyColumn() {
    if (!heroWrap || !stickyCol) return;

    if (window.innerWidth < 992) {
      heroWrap.classList.remove('ic-pdp-hero--synced');
      heroWrap.style.removeProperty('--ic-pdp-hero-min-h');
      heroWrap.style.minHeight = '';
      if (heroImg) heroImg.style.minHeight = '';
      if (heroLink) heroLink.style.minHeight = '';
      return;
    }

    var h = stickyCol.offsetHeight;
    if (h < 320) return;

    heroWrap.classList.add('ic-pdp-hero--synced');
    heroWrap.style.setProperty('--ic-pdp-hero-min-h', h + 'px');
    heroWrap.style.minHeight = h + 'px';
    if (heroLink) heroLink.style.minHeight = h + 'px';
    if (heroImg) heroImg.style.minHeight = h + 'px';
  }

  syncHeroToBuyColumn();
  window.addEventListener('resize', syncHeroToBuyColumn);
  window.addEventListener('load', syncHeroToBuyColumn);

  if (stickyCol && typeof ResizeObserver !== 'undefined') {
    new ResizeObserver(syncHeroToBuyColumn).observe(stickyCol);
  }

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(syncHeroToBuyColumn);
  }

  var root = section.querySelector('.ic-pdp-gallery');
  if (!root) return;

  var targets = root.querySelectorAll('.ic-pdp-reveal');
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function show(el) {
    el.classList.add('is-inview');
  }

  if (targets.length) {
    if (reducedMotion) {
      targets.forEach(show);
    } else {
      var heroReveal = root.querySelector('.ic-pdp-reveal--hero');
      if (heroReveal) {
        requestAnimationFrame(function () {
          show(heroReveal);
        });
      }

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              var el = entry.target;
              var delay = parseInt(el.style.getPropertyValue('--reveal-delay'), 10) || 0;
              if (delay > 0) {
                setTimeout(function () {
                  show(el);
                }, delay);
              } else {
                show(el);
              }
              observer.unobserve(el);
            });
          },
          { root: null, rootMargin: '0px 0px -4% 0px', threshold: 0.1 }
        );

        targets.forEach(function (el) {
          if (!el.classList.contains('ic-pdp-reveal--hero')) {
            observer.observe(el);
          }
        });
      } else {
        targets.forEach(show);
      }

      var heroRevealEl = root.querySelector('.ic-pdp-reveal--hero');
      var heroFrame = root.querySelector('.ic-pdp-gallery__link--hero') || heroRevealEl;
      if (heroFrame && heroRevealEl && !reducedMotion) {
        var ticking = false;
        function onScroll() {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(function () {
            var rect = heroRevealEl.getBoundingClientRect();
            var vh = window.innerHeight || 1;
            if (rect.bottom > 0 && rect.top < vh) {
              var progress = Math.min(1, Math.max(0, 1 - rect.top / vh));
              heroFrame.style.setProperty('--ic-pdp-parallax', progress * 12 + 'px');
            }
            ticking = false;
          });
        }
        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
      }
    }
  }

  setTimeout(syncHeroToBuyColumn, 400);
  setTimeout(syncHeroToBuyColumn, 1200);
})();
